import $ from 'jquery';
import moment from 'moment'

const Const = {
    format: {
        date: "DD.MM.YYYY"
    }
};

export default {
    css: {
        cell: {
            center: 'table-text text-center',
            left  : 'table-text',
            right : 'table-text text-right',
            icon  : 'inbox-table-icon'
        },
        icon: {
            check  : '<i class="far fa-check-square"></i>',
            uncheck: '<i class="far fa-square"></i>'
        }
    },

    deleted( row, data ) {
        if (data.deleted) {
            $('td',   row).addClass('deleted');
            $('td a', row).addClass('deleted');
        }
    },

    empty (value) {
        if (!value)
            value = '&nbsp;';

        return value;
    },

    status (steps) {
        if (steps === null) {
            return "";
        }

       // let div = $('<div>', {
       //     class: 'table-status',
       // });

        let div = $('<div>', {
            class: 'v-flex',
        });

        steps.forEach(step => {
            const sdiv = $('<div>', {
                class: 'table-status',
                html: $('<i>', {
                    class: step.status.font + ' fa-' + step.status.symbol,
                    title: step.name
                })
            });

            div.append (sdiv);
        });

        return $('<div>').append(div).html();
    },

    dates (from, to) {
        let result = $('<div>', {
            html: from ? moment(from).format(Const.format.date) : ''
        });

        result = result.add(
            $('<div>', {
                html: to ? moment(to).format(Const.format.date) : ''
            }));

        return $('<div>').append(result).html();
    },

    textarea (value) {
        value = this.empty(value);
        return $('<div>', {
            class: 'table-textarea',
            html: value ? '<a data-toggle="tooltip" title="' + value + '">' + value + '</a>' : ''
        }).prop('outerHTML')
        ;
    },

    line (value) {
        value = this.empty(value);
        return $('<div>', {
            class: 'hc-table-line',
            html: value
        }).prop('outerHTML')
            ;
    },

    cell (fValue, sValue) {
        const cell = $('<div>', {
            html: $('<a>', {
                html: $('<div>', {
                    class: 'hc-table-line',
                    html: fValue ? fValue : "---"
                }).add(
                    $('<div>', {
                        class: 'hc-table-line',
                        html: sValue ? sValue : "---"
                    })
                )
            })
        });

        if (fValue || sValue) {
            const link = cell.find('a');
            let title = fValue ? fValue : '---';

            if (title.length > 0 && sValue) {
                title = title + '<br>' + sValue ? sValue : '---';
            }

            link.attr('data-toggle', 'tooltip');
            link.attr('title', title);
        }

        return cell.html();
    },

    floatAsString (value) {
        if (!value)
            return "";
        return value.toLocaleString ();
    },

    /**
     * Delegates the hover event to the inner tables of the given panel.
     *
     * @param panel the panel with inner tables.
     */
    hover (panel) {
        panel.find('tr:has(td)')
            .mouseenter(function () {
                $(this).find('tr').css('background-color', 'rgba(0, 0, 0, 0.075)').css('transition', '.5s');
            })
            .mouseleave(function () {
                $(this).find('tr').css('background-color', '')
            });
    },

    tooltips (spanel) {
        spanel.find('[data-toggle="tooltip"]').tooltip({
            html: true,
            placement: 'auto'
        });

        this.hover(spanel);
    },

    removetooltips (spanel) {
        spanel.find('[data-toggle="tooltip"]').tooltip('dispose');

        this.hover(spanel);
    },

    language () {
        return {
            paginate: {
                first: "Erste",
                last: "Letzte",
                next: "Nächste",
                previous: "Vorherige"
            },
            emptyTable: '&nbsp;',
            search: '<i class="fas fa-search"></i>'
        };
    },

    info (settings, start, end, max, total) {
        if (total === 0) {
            return '';
        }

        return start + " bis " + end + ' von insgesamt ' + total + ' ';
    }
}